import styled from '@emotion/styled';
import { SelectMultipleValue } from '@kaizenplatform/hugot-entity';
import { Typography as _Typography } from '@material-ui/core';
import { ClassAttributes, createElement, Fragment, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { DynamicSchemaDefinitionSelectMultiple } from '../../../../../generated/graphql';
import Base from './Base';

interface Props {
  field: Pick<DynamicSchemaDefinitionSelectMultiple, 'choices' | 'label'>;
  value: SelectMultipleValue;
  latestValue: SelectMultipleValue;
  beforeValue: SelectMultipleValue;
  className?: string;
}

const AsMultipleSelection = ({ field, latestValue, beforeValue, className }: Props & ClassAttributes<HTMLElement>) => {
  const latestChoice: any = [];
  const latestItems = latestValue
    .reduce((whole, isChecked, key) => {
      const correspondingChoice = field.choices.find((choice) => choice.key === key);
      latestChoice.push(correspondingChoice);
      if (isChecked && correspondingChoice) {
        return [...whole, ', ', <span key={key}>{correspondingChoice.label}</span>];
      }

      return whole;
    }, [] as ReactNode[])
    .slice(1);

  const beforeChoise: any = [];
  const beforeItems = beforeValue
    .reduce((whole, isChecked, key) => {
      const correspondingChoice = field.choices.find((choice) => choice.key === key);
      beforeChoise.push(correspondingChoice);
      if (isChecked && correspondingChoice) {
        return [...whole, ', ', <span key={key}>{correspondingChoice.label}</span>];
      }

      return whole;
    }, [] as ReactNode[])
    .slice(1);

  return (
    <Base field={field} className={className}>
      {JSON.stringify(beforeChoise) === JSON.stringify(latestChoice) ? (
        latestItems.length === 0 ? (
          <Value>
            <FormattedMessage id={'creative_brief_detail.field.empty'} />
          </Value>
        ) : (
          <Value variant="body1">{latestItems}</Value>
        )
      ) : (
        <>
          <Before variant="body1">{beforeItems.length ? beforeItems : '　'}</Before>
          <After variant="body1">{latestItems.length ? latestItems : '　'}</After>
        </>
      )}
    </Base>
  );
};

const Value = styled(_Typography)({});

const Before = styled(_Typography)({
  padding: '4px',
  marginBottom: '8px',
  background: '#fdd7d5',
});

const After = styled(_Typography)({
  padding: '4px',
  background: '#c8ffd8',
});

export default AsMultipleSelection;
